import { Link } from 'react-router-dom';

export function NotFoundPage() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-center p-8">
            <p className="text-6xl font-bold text-text-subtle">404</p>
            <h1 className="text-xl font-semibold text-text">Page not found</h1>
            <p className="text-sm text-text-muted">The page you're looking for doesn't exist or has moved.</p>
            <Link to="/" className="text-sm text-accent-text hover:underline">Go to dashboard</Link>
        </div>
    );
}
